// Geste universel : laisser la souris sur une bouteille (ou le doigt appuyé)
// ouvre automatiquement le zoom en grand après un court délai.
// Fonction fabrique (pas un hook) : sûre à appeler dans des listes.
export function pressZoom(onZoom, delay = 450) {
  let timer = null;

  const start = () => {
    clearTimeout(timer);
    timer = setTimeout(onZoom, delay);
  };
  const cancel = () => clearTimeout(timer);

  return {
    onMouseEnter: start,
    onMouseLeave: cancel,
    onTouchStart: start,
    onTouchEnd: cancel,
    onTouchMove: cancel,
  };
}
